// Again home "Find your pair" (v3 Task 4). Three taps → one real style, fixed table below.
// No storage, no cookies, no network, no tracking: answers live in this object and vanish on reload.
// Keyboard: every option is a <button>; focus moves to the next question / the result heading.

// [job][pain] → handle for women's sizes. Claim scope = copy deck §5 claims tables: a symptom answer
// only goes to a style whose own claims back it. Heel: cushioned heel = Again Shift only (SH-3); arch:
// built-in arch support = Again Clog only (CL-2) → Clog for kitchen, Shift otherwise. Swelling / toe room:
// wide toe box = Again Shift (SH-2) and Again Clog (CL-3) → Clog for kitchen, Shift otherwise.
// "Just tired" makes no part claim, so it can go to any style. Fallback: Again Shift.
const WOMEN = {
  nurse: { heel: 'again-shift-womens', swell: 'again-shift-womens', tired: 'again-lift' },
  teacher: { heel: 'again-shift-womens', swell: 'again-shift-womens', tired: 'again-glide' },
  kitchen: { heel: 'again-clog', swell: 'again-clog', tired: 'again-clog' },
  warehouse: { heel: 'again-shift-womens', swell: 'again-shift-womens', tired: 'again-lift' },
  other: { heel: 'again-shift-womens', swell: 'again-shift-womens', tired: 'again-glide' },
};
// Men: swelling / toe room → Again Wide (extra-wide fit, WD-1). No men's style has a heel or arch
// claim, so heel answers also go to Wide, with the neutral lead below (no heel/arch promise).
const MEN = { heel: 'again-wide', swell: 'again-wide', tired: 'again-lift' };
const FALLBACK = 'again-shift-womens';

// The symptom lead prints only when the picked style's claims back that symptom (BACKS);
// otherwise the neutral lead. Why this style: the style's kicker from snippet again-copy (the copy
// deck), rendered by Liquid as data-why on each hidden card — one source with the PDP.
const BACKS = {
  heel: ['again-shift-womens', 'again-clog'],
  swell: ['again-shift-womens', 'again-clog', 'again-wide'],
  tired: null,
};
const LEAD = {
  heel: 'For heels and arches that ache by the end, start with',
  swell: 'For feet that swell and toes that feel squeezed, start with',
  tired: 'For feet that are just done by home time, start with',
  neutral: 'Based on your answers, start with',
};
export function lead(pain, handle) {
  const ok = BACKS[pain] === null || (BACKS[pain] || []).includes(handle);
  return ok && LEAD[pain] ? LEAD[pain] : LEAD.neutral;
}
const GUIDE = {
  a: { title: 'The 12-Hour Shift Guide for Your Feet', other: 'The Heel & Arch Reset' },
  b: { title: 'The Heel & Arch Reset', other: 'The 12-Hour Shift Guide for Your Feet' },
};

export function pick(job, pain, who) {
  if (who === 'men') return MEN[pain] || 'again-wide';
  return (WOMEN[job] || WOMEN.other)[pain] || FALLBACK;
}

class AghQuiz extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.hidden = false;
    this.closest('.agh-quiz')?.querySelector('[data-agq-fallback]')?.setAttribute('hidden', '');
    this.steps = [...this.querySelectorAll('[data-agq-step]')];
    this.answers = {};
    this.index = 0;
    this.steps.forEach((step, i) => {
      step.querySelectorAll('.agh-quiz__opt').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.answers[step.dataset.agqStep] = btn.dataset.value;
          step.querySelectorAll('.agh-quiz__opt').forEach((b) => b.setAttribute('aria-pressed', b === btn));
          if (i < this.steps.length - 1) this.go(i + 1, true);
          else this.result();
        });
        btn.setAttribute('aria-pressed', 'false');
      });
      step.querySelector('[data-agq-back]')?.addEventListener('click', () => this.go(i - 1, true));
    });
    this.querySelector('[data-agq-restart]')?.addEventListener('click', () => {
      this.answers = {};
      this.querySelectorAll('.agh-quiz__opt').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      this.go(0, true);
    });
  }

  go(i, focus) {
    this.index = i;
    this.steps.forEach((s, k) => (s.hidden = k !== i));
    this.querySelector('[data-agq-result-body]').hidden = true;
    this.querySelector('[data-agq-progress]').hidden = false;
    this.querySelectorAll('.agh-quiz__dot').forEach((d, k) => d.classList.toggle('is-on', k <= i));
    this.querySelector('[data-agq-count]').textContent = `Step ${i + 1} of ${this.steps.length}`;
    if (focus) this.steps[i].querySelector('legend')?.focus();
  }

  result() {
    const { job, pain, who } = this.answers;
    const handle = pick(job, pain, who);
    let card = null;
    this.querySelectorAll('[data-agq-product]').forEach((el) => {
      const on = el.dataset.agqProduct === handle;
      el.hidden = !on;
      if (on) card = el;
    });
    const name = card ? card.dataset.title : 'Again';
    // Same rule as the PDP: the product's guide:heel-arch tag (rendered by Liquid) picks the guide.
    const guideKey = card && card.dataset.guide === 'b' ? 'b' : 'a';
    this.querySelectorAll('[data-agq-cover]').forEach((c) => (c.hidden = c.dataset.agqCover !== guideKey));
    this.querySelector('[data-agq-rtitle]').textContent = name;
    this.querySelector('[data-agq-why]').textContent = `${lead(pain, handle)} ${name}. ${card?.dataset.why || ''}`.trim();
    this.querySelector('[data-agq-guide]').textContent = GUIDE[guideKey].title;
    this.querySelector('[data-agq-guide-note]').textContent = `Plus ${GUIDE[guideKey].other}. Every order gets both.`;
    const cta = this.querySelector('[data-agq-cta]');
    cta.href = card ? card.dataset.url : this.dataset.fallback;
    cta.textContent = `See ${name}`;
    this.steps.forEach((s) => (s.hidden = true));
    this.querySelector('[data-agq-progress]').hidden = true;
    this.querySelector('[data-agq-result-body]').hidden = false;
    this.dataset.result = handle;
    this.querySelector('[data-agq-rtitle]').focus();
  }
}
if (!customElements.get('agh-quiz')) customElements.define('agh-quiz', AghQuiz);
